module.exports = __webpack_public_path__ + "static/media/gadzety_kreatywne_02_B.cf046c77.png";